/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { Button, Col } from 'react-bootstrap';
import { useTheme } from '../../../providers/theme';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import toast from 'react-hot-toast';
import { useSMForgotPassword } from '../machines/forgotPassword';
import {
  PageContainer,
  GoBackLink,
  Heading,
  ImageIcon,
  Logo,
  SubHeading,
  FormComp,
  SubmitButton,
} from '../components';
import { vappContainer } from '@/application';
import { ForgotPasswordPageService } from '../services';
import { fillTemplate } from '@vlinder-web/utils-react';
import { Loader } from '@/components';

const getSrv = () => {
  return vappContainer.get<ForgotPasswordPageService>(
    ForgotPasswordPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const { forgotPasswordMachine, forgotPasswordSend, forgotPasswordState } =
    useSMForgotPassword({});
  const [email, setEmail] = useState();
  const theme = useTheme();
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});

  useEffect(() => {
    if (
      forgotPasswordState?.matches('FORGOT_PASSWORD_FAILED') &&
      forgotPasswordState?.event?.data?.value
    ) {
      toast.error(forgotPasswordState?.event?.data?.value);
    }
  }, [
    forgotPasswordState?.matches('FORGOT_PASSWORD_FAILED') &&
      forgotPasswordState?.event?.data?.value,
  ]);

  const renderSubmitButton = () => {
    return <SubmitButton />;
  };

  const onForgotPassword = (data: any) => {
    if (data?.email) {
      setEmail(data?.email);
    }
    forgotPasswordSend('START', {
      payload: {
        email: data?.email ?? email,
      },
    });
  };

  const _renderErrorNotification = () => {
    // if (
    //   forgotPasswordState?.matches('FORGOT_PASSWORD_FAILED') &&
    //   forgotPasswordState?.event?.data?.value
    // ) {
    //   toast.error(forgotPasswordState?.event?.data?.value);
    // }
  };

  const _getPageContent = () => {
    if (forgotPasswordState?.matches('FORGOT_PASSWORD')) {
      return (
        <Loader {...(staticPageContentConfig?.loading?.forgotPassword || {})} />
      );
    }
    if (forgotPasswordState?.matches('FORGOT_PASSWORD_SUCCESS')) {
      console.log(
        'forgotPasswordState?.event?.data?.value =>',
        forgotPasswordState?.event?.data?.value
      );
      return (
        <>
          <Col xs={12} md={12}>
            <Logo
              logoURL={
                staticPageContentConfig?.header?.forgotPasswordSuccess?.logo
              }
            />
            <GoBackLink />
            <Heading
              title={
                staticPageContentConfig?.header?.forgotPasswordSuccess?.title
              }
            />
            <ImageIcon
              imageIconURL={
                staticPageContentConfig?.header?.forgotPasswordSuccess?.iconURL
              }
              height={100}
            />
            <SubHeading
              subHeadingText={fillTemplate(
                staticPageContentConfig?.header?.forgotPasswordSuccess
                  ?.subHeadingText,
                { email: forgotPasswordState?.event?.data?.value?.email }
              )}
            />
          </Col>
          <Col xs={12} md={4}>
            <Button
              type="submit"
              variant="secondary"
              className="w-100 p-2 mb-3"
              style={{ borderRadius: 'unset' }}
              onClick={onForgotPassword}
            >
              Resend
            </Button>
          </Col>
        </>
      );
    }
    return (
      <>
        <Col xs={12} md={12}>
          <Logo
            logoURL={staticPageContentConfig?.header?.forgotPassword?.logo}
          />
          <GoBackLink />
          <Heading
            title={staticPageContentConfig?.header?.forgotPassword?.title}
          />
          <ImageIcon
            imageIconURL={
              staticPageContentConfig?.header?.forgotPassword?.iconURL
            }
            height={100}
          />
          <SubHeading
            subHeadingText={
              staticPageContentConfig?.header?.forgotPassword?.subHeadingText
            }
          />
          <FormComp
            renderSubmitButton={renderSubmitButton}
            onFormSubmit={onForgotPassword}
          />
        </Col>
      </>
    );
  };

  return (
    <PageContainer>
      {_getPageContent()}
      {_renderErrorNotification()}
    </PageContainer>
  );
};
